const updateCompaniesStr = {
  toastr: 'Empresa actualizada',
  toastr1: ' fue actualizada con éxito',
  toastrError: 'Empresa ya registrada',
  toastrError1: 'Ingrese este CNPJ o Nombre ya registrado'
};

export default updateCompaniesStr;
